// extracted by mini-css-extract-plugin
export default {"title":"TopPickItem_title__GjJ9k","itemContainer":"TopPickItem_itemContainer__IORHT"};